<i18n>
{
  "fr": {
    "distance": "{distance} km"
  }
}
</i18n>

<template>
  <div
    class="relay-detail"
    :class="{
      'relay-detail--active': active,
      'relay-detail--no-input': noInput,
    }"
  >
    <label
      :for="id"
      class="relay-detail__label"
      @click="$emit('change', relay)"
    >
      <span v-if="!noInput" class="relay-detail__input">
        <input
          :id="id"
          type="radio"
          name="relay"
          class="base-radio"
          :checked="active"
        />
      </span>

      <span class="relay-detail__info">
        <span class="relay-detail__head">
          <span class="relay-detail__distance">{{ distance }}</span>
          <span class="relay-detail__name">{{ relay.name }}</span>
        </span>
        <span class="relay-detail__address">{{ address }}</span>
      </span>
    </label>

    <RelayOpeningHours
      :data="relay.opening_hours_items"
      v-bind="{ noInput, hoursVisible }"
    />
  </div>
</template>

<script>
import RelayOpeningHours from './RelayOpeningHours.vue';
import Relay from '../../mixins/Relay';

export default {
  name: 'RelayDetail',
  components: { RelayOpeningHours },
  mixins: [Relay],
  props: {
    relay: {
      type: Object,
      required: true,
    },
    active: Boolean,
    noInput: Boolean,
    hoursVisible: Boolean,
  },
  data() {
    return {
      value: this.active,
    };
  },
  computed: {
    /**
     * @returns {string}
     */
    id() {
      return `relay-${
        this.relay.pudo_id || (Math.random() + 1).toString(36).substring(7)
      }`;
    },
    /**
     * @returns {string}
     */
    address() {
      return `${this.addressToString(this.relay)}, ${this.relay.zipcode} ${
        this.relay.city
      }`;
    },
    /**
     * @returns {string}
     */
    distance() {
      return this.$t('distance', {
        distance: new Intl.NumberFormat().format(
          Math.round(this.relay.distance / 100) / 10
        ),
      });
    },
  },
};
</script>
